const Action = 1;
const ExpenseDescriptions = 2;
const Comprovation = 3;
const Refunds = 4;
const ActionManager = 5;
const OtherComprovations = 6;
const Invoice = 7;

export default {
  Action,
  ExpenseDescriptions,
  Comprovation,
  Refunds,
  ActionManager,
  OtherComprovations,
  Invoice
};
